import React, { useState } from 'react';
import StyledDialog from 'src/components/BeaconV2Components/common/StyledDialog/StyledDialog';
import TeamPopupCloseIcon from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Team/TeamPopupCloseIcon';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import AtlasV2CompareMetrics from 'src/components/AtlasV2Components/AtlasV2LayoutComponents/Compare/AtlasV2CompareMetrics';
import { CompareScreens } from 'src/components/BeaconV2Components/BeaconChartWithLegend/ComparePopup/types';
import CompareLanding from 'src/components/BeaconV2Components/BeaconChartWithLegend/ComparePopup/CompareLanding';
import CompareGroups from 'src/components/BeaconV2Components/BeaconChartWithLegend/ComparePopup/CompareGroups';

/**
 * Popup for handling the compare feature for line charts
 */
export default function AtlasV2ComparePopUp(
  props: Omit<React.ComponentProps<typeof StyledDialog>, 'width' | 'height' | 'padding'>
) {
  const [screen, setScreen] = useState<CompareScreens>(CompareScreens.Landing);

  const handleClose = (event?: React.MouseEvent<unknown, MouseEvent>) => {
    if (props.onClose) {
      props.onClose(event, 'backdropClick');
      setScreen(CompareScreens.Landing);
    }
  };

  const screenToInnerContent = {
    [CompareScreens.Landing]: <CompareLanding setScreen={setScreen} />,
    [CompareScreens.Metrics]: <AtlasV2CompareMetrics handleClose={() => handleClose()} />,
    [CompareScreens.Groups]: <CompareGroups handleClose={() => handleClose()} />,
    [CompareScreens.Retailers]: <div>Retailers</div>
  };

  return (
    <StyledDialog
      padding="24px"
      width={360}
      height={screen === CompareScreens.Landing ? 398 : undefined}
      sx={{
        '& .MuiPaper-root': {
          position: 'fixed',
          bottom: 0,
          right: 0
        },
        maxHeight: screen !== CompareScreens.Landing ? 600 : undefined
      }}
      {...props}
    >
      <Flex flexDirection="column">
        <Flex
          justifyContent={screen === CompareScreens.Landing ? 'flex-end' : 'space-between'}
          marginBottom={screen === CompareScreens.Landing ? '12px' : '26px'}
        >
          {screen !== CompareScreens.Landing && (
            <Flex
              alignItems="center"
              onClick={() => setScreen(CompareScreens.Landing)}
              sx={{
                cursor: 'pointer'
              }}
            >
              <ChevronLeft />
              <Text variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                Back
              </Text>
            </Flex>
          )}
          <TeamPopupCloseIcon onClick={handleClose} />
        </Flex>
        {screenToInnerContent[screen]}
      </Flex>
    </StyledDialog>
  );
}
